import apiClient from "../../axios/apiClient";


export const getCameraList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_CAMERALIST_PENDING" });

        const response = await apiClient.get(
          `/api/v1/cameras`,
          {
            params: {
              limit: limit,
              page: page,
              search: search,
              sort: sort,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_CAMERALIST_FULFILLED",
          payload: response.data?.data,
          cameraCount: response.data?.count,
          permissions: response.data?.permissions,
        });
      } catch (error) {
        dispatch({
          type: "GET_CAMERALIST_REJECTED",
          payload: error.response,
        });
      }
    };


export const saveCameraData = (token, data) => async (dispatch) => {
  try {
    dispatch({ type: "ADD_CAMERA_PENDING" });

    const response = await apiClient.post(
      `/api/v1/cameras`,
      data, // Data payload should be the second argument
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_CAMERA_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "ADD_CAMERA_REJECTED", payload: error.response });
  }
};


export const getCameraListById = (token, id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_CAMERALISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/v1/cameras/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_CAMERALISTBYID_FULFILLED",
        payload: response.data?.data,
        cameraCount: response.data?.count,
      });
    } catch (error) {
      dispatch({
        type: "GET_CAMERALISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateCameraData = (token, data, id) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_CAMERA_PENDING" });

    const response = await apiClient.put(
      `/api/v1/cameras/${id}`, // Endpoint URL with City ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_CAMERA_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_CAMERA_REJECTED", payload: error.response });
  }
};


export const updateCameraStatusData = (token, id, status) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_CAMERA_STATUS_PENDING" });
    const data = {
      "status": status
    }
    const response = await apiClient.put(
      `/api/v1/cameras/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_CAMERA_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_CAMERA_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteCameraData = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_CAMERA_PENDING" });

    const response = await apiClient.delete(
      `/api/v1/cameras/${id}`, // Endpoint URL with City ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_CAMERA_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_CAMERA_REJECTED", payload: error.response });
  }
};

export const playCameraData = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "PLAY_CAMERA_PENDING" });

    const response = await apiClient.get(
      `/api/admin/v1/Play-Camera/${id}`, // Endpoint URL with City ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "PLAY_CAMERA_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "PLAY_CAMERA_REJECTED", payload: error.response });
  }
};

export const stopCameraData = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "STOP_CAMERA_PENDING" });

    const response = await apiClient.get(
      `/api/admin/v1/Stop-Camera/${id}`, // Endpoint URL with City ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "STOP_CAMERA_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "STOP_CAMERA_REJECTED", payload: error.response });
  }
};
